<script lang="ts">
  // Kopf einer Dashboard-Zone: Symbol in der Farbe des Bereichs, Name,
  // Lage-Satz -- derselbe Aufbau wie der Kopf einer Sektion
  // (DataTableSection), nur ohne Fläche: unter ihm stehen Karten, keine
  // Tabelle (docs/gestaltung.md: „Kennzahlen dürfen Karten sein").
  //
  // Bis 03.10.2026 stand hier nur ein graues Etikett („SYSTEM"). Die Zone
  // sagte nichts über ihren Zustand, und die Seite war die einzige ohne
  // Bereichsfarbe.
  //
  // Der Bereich kommt vom Elternteil (data-bereich an der Zone): so tragen
  // Symbol, Karten und Kurven darunter dieselbe Farbe.
  import type { Snippet } from "svelte";
  import Icon, { type IconName } from "../Icon.svelte";
  import Lage from "../Lage.svelte";
  import type { LageTeil } from "../lage";

  interface Props {
    icon: IconName;
    label: string;
    /** Wohin der Name führt (Übersicht des Bereichs). */
    href?: string;
    lage?: LageTeil[];
    /** Macht den Lage-Satz zum Link, z. B. zur offenen Meldung. */
    lageHref?: string;
    lageTitle?: string;
    /** Rechts: Werkzeuge der Zone (Anordnen-Leiste, Uhr, Verweis). */
    children?: Snippet;
  }
  let { icon, label, href, lage = [], lageHref, lageTitle, children }: Props = $props();
</script>

<div class="mb-2 flex min-h-8 flex-wrap items-center gap-x-2.5 gap-y-1 px-0.5">
  <span class="kachel zonen-symbol" aria-hidden="true"><Icon name={icon} size={16} /></span>
  <h2 class="text-fg font-semibold">
    {#if href}<a {href} class="hover:text-marke transition-colors">{label}</a>{:else}{label}{/if}
  </h2>
  {#if lage.length}
    {#if lageHref}
      <a href={lageHref} title={lageTitle} class="text-fg-muted min-w-0 t-meta tabular-nums hover:underline">
        <Lage teile={lage} />
      </a>
    {:else}
      <span class="text-fg-muted min-w-0 t-meta tabular-nums"><Lage teile={lage} /></span>
    {/if}
  {/if}
  <span class="flex-1"></span>
  {@render children?.()}
</div>

<style>
  /* Ohne „Farbige Symbole" (Einstellungen › Farbe) bleibt das Symbol
     leise; mit Kacheln färbt .kachel (app.css) in der Bereichsfarbe. */
  :global(html:not([data-farbe-seiten="1"])) .zonen-symbol {
    color: var(--fg-subtle);
  }
</style>
